import cn from 'classnames'
import type { FC, HTMLAttributes } from 'react'
import { usePresence } from '../hooks/presence.js'
import { UserAvatar } from '../profile/index.js'
import { graphHooks } from '@tunasong/graph-lib/react'
import moduleStyles from './presence.module.css'

export interface PresenceProps extends HTMLAttributes<HTMLDivElement> {
  className?: string
  entityId?: string
}

export const Presence: FC<PresenceProps> = props => {
  const { entityId, className, ...restProps } = props

  const userIds = usePresence(entityId)

  /** Load profiles in batch */
  const {} = graphHooks.useProfiles({ userIds })

  if (userIds.length === 0) {
    return null
  }

  return (
    <div className={cn(moduleStyles.container, className)} {...restProps}>
      {userIds.map((userId, idx) => (
        <UserAvatar size="tiny" key={idx} userId={userId} />
      ))}
    </div>
  )
}

export default Presence
